import { Store } from '@ngrx/store';
import { ALERTS_LESS_THAN_OR_EQUAL_STRING_VALUE, ALERTS_OPERATOR_CONFIG, ALERTS_SEARCH_BLOCK_REGEX, LEFT_METRIC_PLACEHOLDER, METRIC_ALERT_LIMIT, RIGHT_METRIC_PLACEHOLDER, } from 'AlertsApp/ts/features/alerts-modals/constants';
import { AlertsService } from 'AlertsApp/ts/services/alerts.service';
import { MetricAutocompleteInPlaceComponent } from 'SearchApp/ts/features/autocomplete-in-place/metric-autocomplete-in-place/metric-autocomplete-in-place.component';
import { getMetricSearchType } from 'NewAngular/utils/metric';
import { resetErrorMessage, setErrorMessage, } from 'AlertsApp/ts/features/alerts-modals/state/alert-modal-status/alert-modal-status.actions';
import { createMetricAlert } from 'AlertsApp/ts/features/alerts-modals/state/metric-alert-items/metric-alert-items.actions';
import * as i0 from "@angular/core";
import * as i1 from "AlertsApp/ts/services/alerts.service";
import * as i2 from "@ngrx/store";
import * as i3 from "../../../../../../../../search/static/search/ts/features/autocomplete-in-place/metric-autocomplete-in-place/metric-autocomplete-in-place.component";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = ["autocompleteLeft"];
const _c1 = ["autocompleteRight"];
const _c2 = () => ({ button: "btn btn-secondary btn-block dropdown-toggle style-underline" });
const _c3 = a0 => ({ disabled: a0 });
/**
 * AlertParamsComponent.
 *
 * Alert modal section to register a new metrics alerts. It uses two MetricAutocompleteInPlaceComponent elements
 * to set up the left and right metrics, plus an operator.
 *
 */
export class AlertParamsComponent {
    constructor(alertsService, store) {
        this.alertsService = alertsService;
        this.store = store;
        this.defaultOnly = false;
        // Data & flags
        this.operator = ALERTS_LESS_THAN_OR_EQUAL_STRING_VALUE;
        this.operatorOptions = ALERTS_OPERATOR_CONFIG;
        this.searchBlockRegex = ALERTS_SEARCH_BLOCK_REGEX;
        this.leftMetricPlaceholder = LEFT_METRIC_PLACEHOLDER;
        this.rightMetricPlaceholder = RIGHT_METRIC_PLACEHOLDER;
        this.autocompleteSearchType = '';
    }
    ngOnInit() {
        this.autocompleteSearchType = getMetricSearchType(this.alertObject.detailedType, false);
    }
    /**
     * Handler for the left metric autocomplete action.
     *
     * @param event: AutocompleteResult object.
     */
    selectLeftMetricAutocompleteHandler(event) {
        if (!event) {
            this.setLeftMetric(undefined, undefined);
        }
        else {
            this.setLeftMetric(event.id, event.name);
        }
    }
    /**
     * Handler for left metric selection from the metrics modal.
     *
     * @param event: Selected metric from the modal.
     */
    selectLeftMetricModalHandler(event) {
        this.setLeftMetric(event.internal_name, event.label);
    }
    /**
     * Sets the values for the left metric.
     *
     * @param metricId: Left metric ID.
     * @param metricName: Left metric name.
     */
    setLeftMetric(metricId, metricName) {
        this.leftMetric = metricId;
        this.leftMetricName = metricName;
    }
    /**
     * Resets the autocomplete and modal values for the left metric.
     */
    resetLeftMetric() {
        this.setLeftMetric(undefined, undefined);
        this.autocompleteLeft.reset();
    }
    /**
     * Handler for the operator dropdown menu.
     *
     * @param operator: Selected operator.
     */
    operatorHandler(operator) {
        this.operator = operator;
    }
    /**
     * Handler for the right metric autocomplete.
     *
     * @param event: AutocompleteResult object.
     */
    selectRightMetricAutocompleteHandler(event) {
        if (!event) {
            this.setRightMetric(true);
        }
        else {
            const isRaw = event.is_raw === true;
            let metricId = event.id;
            // If the object's value is "raw", it is not a metric, so the metric id will be the actual value
            if (isRaw)
                metricId = event.name;
            this.setRightMetric(!isRaw, metricId, event.name);
        }
    }
    /**
     * Handler for the right metric selected from the metrics modal.
     *
     * @param event: Selected right metric.
     */
    selectRightMetricModalHandler(event) {
        this.setRightMetric(true, event.internal_name, event.label);
    }
    /**
     * Sets the values for the right metric.
     *
     * @param metricId: Right metric ID or numeric vlaue.
     * @param metricName: Right metric name.
     * @param isMetric: Whether the right metric is a value or metric.
     */
    setRightMetric(isMetric, metricId, metricName) {
        this.rightMetricOrValue = metricId;
        this.rightMetricOrValueName = metricName;
        this.rightValueIsMetric = isMetric;
    }
    /**
     * Resets the values for the right metric input and modal.
     */
    resetRightMetric() {
        this.rightMetricOrValue = undefined;
        this.rightMetricOrValueName = undefined;
        this.autocompleteRight.reset();
    }
    /**
     * Handler for the submit button. Validates that the action can be executed and then performs the creation.
     */
    alertSubmitHandler() {
        // If the user hasn't filled in both autocompleters, clicking should do nothing
        if (!this.canSubmit()) {
            return;
        }
        // If the user has duplicate metrics in both autocompleters, show an error message
        if (this.leftMetric === this.rightMetricOrValue) {
            this.store.dispatch(setErrorMessage({ errorMessage: 'Please enter 2 different metrics.' }));
            return;
        }
        const alertMetricParams = {
            calculation: this.leftMetric,
            limitType: this.operator,
            limitValue: this.rightMetricOrValue,
            valueIsMetric: this.rightValueIsMetric,
        };
        this.createMetricAlert(alertMetricParams);
        this.resetLeftMetric();
        this.resetRightMetric();
    }
    /**
     * Creates a new alert based on a AlertMetricParams object and the current object.
     * Dispatches `createMetricAlert` to add the new alert to the state.
     *
     * @param alertMetricParams: Params for the alert to be created.
     */
    createMetricAlert(alertMetricParams) {
        this.alertsService
            .createAlert(METRIC_ALERT_LIMIT, this.alertObject.type, this.alertObject.id, alertMetricParams)
            .subscribe({
            next: (createAlert) => {
                this.store.dispatch(createMetricAlert({ alert: createAlert.alert }));
                this.store.dispatch(resetErrorMessage());
            },
            error: () => {
                this.store.dispatch(setErrorMessage({
                    errorMessage: 'Alert creation failed. Please refresh the page or contact support.',
                }));
            },
        });
    }
    /**
     * Returns true if the submit button can be enabled.
     */
    canSubmit() {
        return this.leftMetric !== undefined && this.rightMetricOrValue !== undefined;
    }
}
AlertParamsComponent.ɵfac = function AlertParamsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AlertParamsComponent)(i0.ɵɵdirectiveInject(i1.AlertsService), i0.ɵɵdirectiveInject(i2.Store)); };
AlertParamsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AlertParamsComponent, selectors: [["ycn-alert-params"]], viewQuery: function AlertParamsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteLeft = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteRight = _t.first);
    } }, inputs: { alertObject: "alertObject", defaultOnly: "defaultOnly" }, standalone: false, decls: 20, vars: 22, consts: [["autocompleteLeft", ""], ["autocompleteRight", ""], [1, "form-row", "row"], [1, "col-4", "form-row"], [1, "form-label", "form-label-thin", "form-row"], [1, "field-search-browse-wrap", 3, "submitHandler", "submitModalHandler", "editHandler", "appendToBody", "displayIdentifier", "hideCancelButton", "placeholder", "searchType", "tooltipText", "defaultOnly"], [1, "col-2", "form-row"], [3, "changeHandler", "customCssClasses", "selectedValue", "config"], [1, "field-search-browse-wrap", 3, "submitHandler", "submitModalHandler", "editHandler", "appendToBody", "displayIdentifier", "hideCancelButton", "placeholder", "searchType", "searchBlockRegex", "tooltipText", "defaultOnly"], ["data-test-id", "alert-params-submit-button", 1, "col-2", "form-row", 3, "click"], [1, "btn", "btn-block", "btn-primary", 3, "ngClass"]], template: function AlertParamsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
        i0.ɵɵtext(3, "Metric");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "ycn-metric-autocomplete-in-place", 5, 0);
        i0.ɵɵlistener("submitHandler", function AlertParamsComponent_Template_ycn_metric_autocomplete_in_place_submitHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectLeftMetricAutocompleteHandler($event)); })("submitModalHandler", function AlertParamsComponent_Template_ycn_metric_autocomplete_in_place_submitModalHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectLeftMetricModalHandler($event)); })("editHandler", function AlertParamsComponent_Template_ycn_metric_autocomplete_in_place_editHandler_4_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.resetLeftMetric()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 4);
        i0.ɵɵtext(8, "Operator");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "ycn-single-select-dropdown", 7);
        i0.ɵɵlistener("changeHandler", function AlertParamsComponent_Template_ycn_single_select_dropdown_changeHandler_9_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.operatorHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 3)(11, "div", 4);
        i0.ɵɵtext(12, "NUMBER OR METRIC");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "ycn-metric-autocomplete-in-place", 8, 1);
        i0.ɵɵlistener("submitHandler", function AlertParamsComponent_Template_ycn_metric_autocomplete_in_place_submitHandler_13_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectRightMetricAutocompleteHandler($event)); })("submitModalHandler", function AlertParamsComponent_Template_ycn_metric_autocomplete_in_place_submitModalHandler_13_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectRightMetricModalHandler($event)); })("editHandler", function AlertParamsComponent_Template_ycn_metric_autocomplete_in_place_editHandler_13_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.resetRightMetric()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "div", 9);
        i0.ɵɵlistener("click", function AlertParamsComponent_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.alertSubmitHandler()); });
        i0.ɵɵelementStart(16, "div", 4);
        i0.ɵɵtext(17, "\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 10);
        i0.ɵɵtext(19, " Create ");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("appendToBody", true)("displayIdentifier", null)("hideCancelButton", true)("placeholder", ctx.leftMetricPlaceholder)("searchType", ctx.autocompleteSearchType)("tooltipText", "Enter Metric")("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(19, _c2))("selectedValue", ctx.operator)("config", ctx.operatorOptions);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("appendToBody", true)("displayIdentifier", null)("hideCancelButton", true)("placeholder", ctx.rightMetricPlaceholder)("searchType", ctx.autocompleteSearchType)("searchBlockRegex", ctx.searchBlockRegex)("tooltipText", "Edit Metric or Value")("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c3, !ctx.canSubmit()));
    } }, dependencies: [i3.MetricAutocompleteInPlaceComponent, i4.NgClass, i5.SingleSelectDropdownComponent], encapsulation: 2 });
